/**
 * Utilities for in-browser PDF preview, download, and print.
 * Blob/object-URL lifecycle: only URLs created via createObjectURL must be revoked.
 */

export function parsePdfFileNameFromContentDisposition(contentDisposition, fallback = 'document.pdf') {
    if (!contentDisposition) return fallback;
    const match = contentDisposition.match(/filename="(.+)"/);
    return match?.[1] || fallback;
}

export function revokeObjectUrlIfOwned(objectUrl, ownsObjectUrl) {
    if (ownsObjectUrl && objectUrl) {
        URL.revokeObjectURL(objectUrl);
    }
}

export function downloadPdfBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    URL.revokeObjectURL(url);
}

export async function fetchUrlAsPdfBlob(fileUrl) {
    const response = await fetch(fileUrl);
    if (!response.ok) {
        throw new Error('Échec du chargement du document');
    }
    return response.blob();
}

export function printPdf({ fileUrl, blob }) {
    return new Promise((resolve, reject) => {
        let printUrl = fileUrl;
        let revokeAfterPrint = false;

        if (blob) {
            printUrl = URL.createObjectURL(blob);
            revokeAfterPrint = true;
        }

        if (!printUrl) {
            reject(new Error('Aucun document à imprimer'));
            return;
        }

        const iframe = document.createElement('iframe');
        iframe.setAttribute('title', 'Impression PDF');
        Object.assign(iframe.style, {
            position: 'fixed',
            right: '0',
            bottom: '0',
            width: '0',
            height: '0',
            border: 'none',
        });
        document.body.appendChild(iframe);

        const cleanup = () => {
            if (iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
            }
            if (revokeAfterPrint) {
                URL.revokeObjectURL(printUrl);
            }
        };

        iframe.onerror = () => {
            cleanup();
            reject(new Error('Impossible d\'imprimer le document'));
        };

        iframe.onload = () => {
            setTimeout(() => {
                try {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                    setTimeout(() => {
                        cleanup();
                        resolve();
                    }, 1000);
                } catch (error) {
                    cleanup();
                    reject(error);
                }
            }, 300);
        };

        iframe.src = printUrl;
    });
}
